<template>
<div
  class="permissions-form"
  v-if="$can('roles.create|roles.edit', user)"
  :loading="loading"
>
  <div class="row">
    <div class="col-lg-8 col-xs-12">
      <p style="font-size: 2em;">
        Perfil
        <input
          type="text"
          v-if="isNewRole"
          v-model.trim="role.label"
        />
        <span v-else>{{ role.label }}</span>
      </p>
    </div>
    <div class="col-lg-4 col-xs-12 text-right">
      <button
        :disabled="saving"
        @click="handleSave()"
        class="btn btn-fill btn-wd btn-primary"
      >Salvar
      </button>
    </div>
  </div>

  <div
    v-for="(module, indexModule) in permissions"
    :key="indexModule"
  >
    <h3>{{ module.label }}</h3>
    <div class="row">
      <div
        class="col-lg-3 col-md-6 col-xs-12"
        v-for="(subModule, indexSubModule) in module.subModules"
        :key="indexSubModule"
      >
        <h5>{{ subModule.label }} </h5>

        <div class="checkbox">
          <input
            type="checkbox"
            :id="subModule.label"
            @change="checkAll(subModule.permissions.map(permission => { return permission.value }), $event)"
          >
          <label :for="subModule.label">Marcar / Desmarcar todos</label>
        </div>

        <div
          class="checkbox"
          v-for="(permission, index) in subModule.permissions"
          :key="index"
        >
          <input
            class=""
            type="checkbox"
            :id="permission.value"
            :value="permission.value"
            v-model="role.permissions"
          >
          <label :for="permission.value">{{ permission.label }}</label>
        </div>

      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'roles-form',
  data () {
    return {
      saving: false,
      loading: true
    }
  },
  computed: {
    ...mapGetters(['user']),

    ...mapGetters('roles', {
      permissions: 'permissions',
      role: 'role',
      allPermissions: 'roles'
    }),

    isNewRole () {
      return this.$route.name !== 'roles.edit'
    }
  },
  methods: {
    ...mapActions('roles', ['insert', 'update', 'fetchOne', 'resetOne', 'fetchAll']),
    checkAll (permissions, event) {
      permissions.forEach(permission => {
        if (event.target.checked) {
          this.role.permissions.push(permission)
        } else {
          this.role.permissions.splice(this.role.permissions.indexOf(permission), 1)
        }
      })
    },
    handleSave () {
      this.saving = true
      this.role.name = this.role.label.replace(/ /g, '').toLowerCase()
      this.role.collection = 'roles'
      if (this.isNewRole && typeof this.role._id === 'undefined') {
        this.insert(this.role)
          .then(result => {
            this.saving = false
            this.$notify({
              message: 'Registro criado com sucesso.',
              type: 'success'
            })
            this.$router.push({ name: 'roles.index' })
          })
          .catch(err => {
            this.saving = false
            console.log(err)
          })
      } else if (!this.isNewRole && typeof this.role._id !== 'undefined') {
        this.update(this.role)
          .then(result => {
            this.saving = false
            this.$notify({
              message: 'Registro editado com sucesso.',
              type: 'success'
            })
            this.$router.push({ name: 'roles.index' })
          })
          .catch(err => {
            this.saving = false
            console.log(err)
          })
      }
    }
  },
  mounted () {
    this.saving = false
    if (!this.allPermissions || this.allPermissions.length <= 0) {
      this.fetchAll()
    }
    this.resetOne()
    if (!this.isNewRole) {
      this.fetchOne(this.$route.params.id)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Roles/RolesForm.vue